/**
 * Note that the string must start with a #
 * If we set that as dependency here we have to recast
 * all usage of window.location.hash as an example, since this is type string.
 */
type Hash = string;

export function isHash(hash: string): hash is Hash {
  return hash.startsWith('#');
}

let globalHashScrollOffset = 100;
export function setHashScrollOffset(offset: number) {
  globalHashScrollOffset = offset;
}

export function scrollToHash(hash: Hash, animate = true, hashScrollOffset = globalHashScrollOffset) {
  let anchorElement = document.getElementById(hash.substring(1));
  if (!anchorElement) {
    anchorElement = document.querySelector('*[data-scroll-id=' + hash.substring(1) + ']');
  }
  if (anchorElement) {
    const offset = offsetTop(anchorElement as HTMLElement) - hashScrollOffset;
    if (animate) {
      scrollTo(offset);
    } else {
      scrollPosition(offset);
    }
    return true;
  } else {
    return false;
  }
}

export function scrollPosition(newPosition?: number) {
  const element = document.scrollingElement || document.documentElement || document.body;

  if (newPosition !== undefined) {
    element.scrollTop = newPosition;
  }

  return element.scrollTop;
}

export function offsetTop(element: HTMLElement): number {
  if (!element) {
    return 0;
  }
  return element.offsetTop + offsetTop(element.offsetParent as HTMLElement);
}

export function offsetLeft(element: HTMLElement): number {
  if (!element) {
    return 0;
  }
  return element.offsetLeft + offsetLeft(element.offsetParent as HTMLElement);
}

export function scrollTo(to: number) {
  window.scrollTo({ top: to, behavior: 'smooth' });
}
